"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var SummaryExtendedLiteView_1 = require("../../../summary/components/summaryViews/SummaryExtendedLiteView");
var GoHomeButton_1 = require("../GoHomeButton/GoHomeButton");
var core_1 = require("@material-ui/core");
var useWidgetContext_1 = require("../../../../../common/react/useWidgetContext");
var useCheckoutContext_1 = require("../../../../common/hooks/useCheckoutContext");
var usePlatformConfig_1 = require("../../../../../common/react/usePlatformConfig");
var MySummaryExpandedCtaContainer_1 = require("./MySummaryExpandedCtaContainer");
var MySummaryExpanded = function () {
    var homePageURL = useWidgetContext_1.default().configuration.homePageURL;
    var myAccountDxpIntegration = usePlatformConfig_1.default().platformConfig.platformFeatures.myAccountDxpIntegration;
    var _a = useCheckoutContext_1.default(), deal = _a.deal, loading = _a.loading;
    if (loading || !deal) {
        return null;
    }
    return (<>
      {myAccountDxpIntegration ? (<MySummaryExpandedCtaContainer_1.MySummaryExpandedCtaContainer homePageURL={homePageURL} myAccountDxpIntegration={myAccountDxpIntegration}/>) : (<GoHomeButton_1.default homePageURL={homePageURL}/>)}
      <core_1.Box display="flex" flexGrow={1}>
        <SummaryExtendedLiteView_1.default deal={deal}/>
      </core_1.Box>
    </>);
};
exports.default = MySummaryExpanded;
